import { useTranslation } from '@/hooks/useTranslation';
import { Sparkles } from 'lucide-react';

export const AIWelcomeScreen = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center flex-1 gap-4 text-center px-6">
      <div className="rounded-full bg-primary/0 p-4">
        <Sparkles className="size-8 text-secondary" />
      </div>
      <div>
        <h2 className="text-xl font-semibold">{t('aiChat.welcome.title')}</h2>
        <p className="text-muted-foreground text-sm mt-1 max-w-sm">{t('aiChat.welcome.description')}</p>
      </div>
    </div>
  );
};
